import React from "react";
import { ViewType } from "../AdminPanel";
import { getAdminPermissions } from "../adminApi";
import { useLanguage } from "../context/LanguageContext";

interface SidebarProps {
  activeView: ViewType;
  setActiveView: (view: ViewType) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeView, setActiveView }) => {
  const permissions = getAdminPermissions();
  const { t } = useLanguage();
  
  const menuItems: ViewType[] = [
    "Lock types",
    "Lock properties",
    "Supplier Icon",
    "Database preview",
    "Backups",
    "Tax change",
    "Database update",
    "Users",
  ].filter(item => permissions.includes(item)) as ViewType[];

  return (
    <div className="sidebar">
      <h2 className="sidebar-title">{t("Menu")}</h2>
      <ul>
        {menuItems.map((item) => (
          <li
            key={item}
            className={activeView === item ? "active" : ""}
            onClick={() => setActiveView(item)}
          >
            {t(item)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;